import plantsClient from '@/core/services/plants';
import { isCodeCorrectValue } from '@/core/utils/EntrancePlant/entrance-plant.utils';
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'KeypadCodeInput',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    keypadCodeRequiredLength: {
      type: Number,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
    labelId: {
      type: Number,
      required: false,
      default: 0,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    keypadCode: function (value: string, oldValue: string) {
      if (value !== oldValue && this.keypadCodeEdited()) {
        this.resetValidation();
      }
      this.codeWasEdited();
    },
    codeCheck: function () {
      this.codeWasEdited();
    },
  },

  emits: ['key-code-edited', 'error-key-code', 'update:modelValue'],
})
export default class KeypadCodeInput extends Vue {
  modelValue!: string;
  keypadCodeRequiredLength!: number;
  fullWidth!: boolean;
  label!: string;
  labelId!: number;
  codeCheck: string = '';
  codeNotValid = false;
  codeValid = false;
  lengthNotValid = false;
  oldKeypadCode = '';
  disabled!: boolean;

  mounted() {
    if (this.modelValue) {
      this.oldKeypadCode = this.modelValue;
      this.keypadCode = this.modelValue;
      this.codeCheck = this.modelValue;
    }
  }

  get keypadCode() {
    return this.modelValue;
  }

  set keypadCode(v: any) {
    this.$emit('update:modelValue', v);
  }

  get enableConfirmation() {
    const enable = this.isCorrectValue;
    if (!enable) {
      this.codeCheck = '';
    }
    return enable;
  }

  get isCorrectValue() {
    return isCodeCorrectValue(this.keypadCode, this.keypadCodeRequiredLength);
  }

  get enableShare() {
    //TODO implement share
    return this.codeCheck !== '' && this.codeCheck === this.keypadCode;
  }

  get codeInputHasError() {
    const errorCodeValidation = this.codeCheck !== this.keypadCode;
    return errorCodeValidation;
  }

  codeWasEdited() {
    this.$emit('error-key-code', this.codeInputHasError);
    this.$emit('key-code-edited', this.keypadCodeEdited(), this.keypadCode, this.labelId);
  }

  checkCodeLength() {
    this.lengthNotValid = this.keypadCode !== '' && !this.isCorrectValue;
  }

  resetLengthValidation() {
    this.lengthNotValid = false;
  }

  checkCodeValid() {
    if (this.codeCheck.trim() !== '' || this.keypadCode.trim() !== '') {
      this.codeNotValid = this.codeCheck !== this.keypadCode;
      this.codeValid =
        this.isCorrectValue && this.codeCheck === this.keypadCode;
    }
  }

  resetValidation() {
    this.codeNotValid = false;
    this.codeValid = false;
  }

  keypadCodeEdited() {
    if (this.keypadCode !== '') {
      return (
        this.codeCheck === this.keypadCode &&
        this.keypadCode !== this.oldKeypadCode
      );
    } else {
      return this.keypadCode !== this.oldKeypadCode;
    }
  }

  async codeGenerator() {
    this.resetValidation();
    this.resetLengthValidation();
    const randStr = await plantsClient.randomkeypadcode(
      this.keypadCodeRequiredLength
    );
    this.keypadCode = randStr.toString();
    this.codeCheck = randStr.toString();
  }
}
